module.exports = __webpack_public_path__ + "img/pic1.12a33abc.jpg";